"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.646 9.146a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L12 10.207l-5.646 5.647a.5.5 0 0 1-.708-.708z"
}), 'ArrowUpThin');
